"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ZINDEX = void 0;
const ZINDEX = {
  behind: -1,
  bottom: 0,
  middle: 10,
  top: 20,
  super: 2000
};
exports.ZINDEX = ZINDEX;
var _default = ZINDEX;
exports.default = _default;